module.exports = "precision mediump float;\n#define GLSLIFY 1\n\nuniform vec3 u_base_color;\nuniform vec3 u_fire_color;\n\nvarying vec2 v_uv;\nvarying float v_high_noise;\n\nvoid main() {\n    vec3 noiseColor = mix(u_base_color, u_fire_color, v_high_noise);\n\n    gl_FragColor = vec4(noiseColor, 1.);\n}\n"


//////////////////
// WEBPACK FOOTER
// ./three/shaders/fireplane_shader.frag
// module id = 381
// module chunks = 0